import { Form } from 'antd';
import React, { FunctionComponent, useState } from 'react';
import { ConsentCheckbox } from '../../styles/ConsentCheckbox';
import { FlowContentBody, QuestionWrapper } from '../../styles/Containers';
import { TextInput } from '../../styles/TextInput';
import { BodySM, HeroTitle } from '../../styles/Typography';
import { AuthorizationConfig, FullAuthorization } from './FullAuthorization';
import { LayoutActions } from './LayoutActions';

export type CoverageEmployerLayoutConfig = {
  title: string;
  body: string[];
  inputLabel: string;
  inputPlaceholder: string;
  /** The optional employer-outreach consent, in the health-plan authorization's format. */
  authorization: AuthorizationConfig;
  primaryButtonTitle: string;
};

export type CoverageEmployerSubmission = {
  employer: string;
  outreachConsent: boolean;
};

type Props = CoverageEmployerLayoutConfig & {
  prefill?: Partial<CoverageEmployerSubmission>;
  onPressPrimaryButton: (submission: CoverageEmployerSubmission) => void;
};

export const CoverageEmployerLayout: FunctionComponent<Props> = (props) => {
  const [employer, setEmployer] = useState(props.prefill?.employer ?? '');
  const [outreachConsent, setOutreachConsent] = useState(props.prefill?.outreachConsent ?? false);
  const canSubmit = employer.trim().length > 0;

  function onPrimaryPress(): void {
    if (!canSubmit) return;
    props.onPressPrimaryButton({ employer: employer.trim(), outreachConsent });
  }

  return (
    <Form>
      <QuestionWrapper>
        <FlowContentBody>
          <HeroTitle data-test="surveyQuestion">{props.title}</HeroTitle>
          {props.body.map((line, index) => (
            <BodySM key={index}>{line}</BodySM>
          ))}
          <Form.Item>
            <TextInput
              type="text"
              autoComplete="organization"
              value={employer}
              placeholder={props.inputPlaceholder}
              aria-label={props.inputLabel}
              data-testid="coverage-employer-input"
              onChange={({ target: { value } }) => setEmployer(value)}
            />
          </Form.Item>
          <ConsentCheckbox
            checked={outreachConsent}
            onChange={setOutreachConsent}
            label={props.authorization.label}
            testId="coverage-employer-consent"
          >
            <FullAuthorization
              config={props.authorization}
              testId="coverage-employer-authorization"
            />
          </ConsentCheckbox>
        </FlowContentBody>
        <LayoutActions
          primaryButtonTitle={props.primaryButtonTitle}
          onPressPrimaryButton={onPrimaryPress}
          primaryButtonDisabled={!canSubmit}
        />
      </QuestionWrapper>
    </Form>
  );
};
